import i18n from '@/i18n'

export default {
  tractVisitHeaders () {
    return [
      {
        sortable: true,
        text: i18n.t('visitType'),
        value: 'tractVisitTypeName'
      },
      {
        sortable: true,
        text: i18n.t('createdBy'),
        value: 'createdByUserName'
      },
      {
        sortable: true,
        text: i18n.t('completedAt'),
        value: 'completedAt'
      },
      {
        sortable: false,
        text: i18n.t('notes'),
        value: 'notes'
      },
      {
        sortable: false,
        text: i18n.t('actions'),
        value: 'actions',
        align: 'center',
        hidable: false
      }
    ]
  },

  tractVisitMobileHeaders () {
    return [
      {
        sortable: false,
        text: i18n.t('visitType'),
        value: 'tractVisitTypeName'
      },
      {
        sortable: false,
        text: i18n.t('completedAt'),
        value: 'completedAt'
      },
      {
        sortable: false,
        text: i18n.t('actions'),
        value: 'actions',
        align: 'center',
        hidable: false
      }
    ]
  },

  tractVisitAttachmentHeaders () {
    return [
      {
        sortable: true,
        text: i18n.t('filename'),
        value: 'name'
      },
      {
        sortable: true,
        text: i18n.t('type'),
        value: 'type'
      },
      {
        sortable: false,
        text: i18n.t('actions'),
        value: 'actions',
        align: 'center',
        hidable: false
      }
    ]
  },

  tractVisitTypeHeaders () {
    return [
      {
        sortable: true,
        text: i18n.t('name'),
        value: 'name'
      },
      {
        sortable: false,
        text: i18n.t('description'),
        value: 'description'
      },
      {
        sortable: false,
        text: i18n.t('actions'),
        value: 'actions',
        align: 'center'
      }
    ]
  }
}
